import React from "react";
import "./ServiceCard.css";

function ServiceCard({ title, image, details, expanded, onToggle, onBookNow }) {
    return (
        <div className="service-card">
            <div className="service-content">
                <img src={image} alt={title} className="service-img" />
                <h3 className="service-title">{title}</h3>

                {/* Details with inline Read More */}
                <ul className="service-details">
                    <li>
                        {details[0]}
                        {!expanded && (
                            <button className="readmore-inline" onClick={onToggle}>
                                ...Read More
                            </button>
                        )}
                    </li>
                    {expanded &&
                        details.slice(1).map((detail, i) => (
                            <li key={i}>{detail}</li>
                        ))}

                    {/* Inline Show Less when expanded */}
                    {expanded && (
                        <li>
                            <button className="showless-inline" onClick={onToggle}>
                                Show Less
                            </button>
                        </li>
                    )}
                </ul>
            </div>

            {/* Book Now stays at bottom */}
            <div className="service-buttons">
                <button className="book-btn" onClick={onBookNow}>
                    Book Now
                </button>
            </div>
        </div>
    );
}

export default ServiceCard;
